import { useRef, useState } from "react";
import { ChevronDownIcon } from "../../icons";
import useClickOutside from "./useClickOutside";

const TRANSACTION_TYPE_OPTIONS = [
  "All Transactions",
  "Buy",
  "Sell",
  "Withdraw",
  "Deposit",
];

const TransactionTypeFilter = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useClickOutside(containerRef, isOpen, () => setIsOpen(false));

  return (
    <div ref={containerRef} className="relative shrink-0">
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        className="flex h-9 items-center justify-center gap-[7px] rounded-[6px] border border-solid border-divider bg-background-surface px-2 custom-transition hover:bg-option-hover"
      >
        <span className="whitespace-nowrap text-sm font-medium leading-[19.5px] text-text-primary">
          {value}
        </span>
        <ChevronDownIcon
          size={16}
          className={`text-text-secondary custom-transition ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div
          className="absolute border border-solid border-divider right-0 top-[calc(100%+4px)] z-50 w-[138px] overflow-hidden rounded-[8px] bg-background-surface pt-2 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.16)]"
          role="listbox"
        >
          {TRANSACTION_TYPE_OPTIONS.map((option) => {
            const isSelected = option === value;

            return (
              <button
                key={option}
                type="button"
                role="option"
                aria-selected={isSelected}
                onClick={() => {
                  onChange(option);
                  setIsOpen(false);
                }}
                className={`flex w-full items-center px-3 py-2.5 text-left custom-transition ${
                  isSelected
                    ? "bg-[rgba(74,185,50,0.08)]"
                    : "hover:bg-[rgba(74,185,50,0.04)]"
                }`}
              >
                <span
                  className={`whitespace-nowrap text-xs font-medium leading-[19.5px] ${
                    isSelected ? "text-[#4ab932]" : "text-text-primary"
                  }`}
                >
                  {option}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TransactionTypeFilter;
